/**
 * CardHeader — title + optional subtitle + optional right-aligned slot,
 * matched to the dense data-UI density (px-4 py-3) used in design/ui.
 */
import type { ReactNode } from 'react';
import { cn } from './cn';

export interface CardHeaderProps {
  title: ReactNode;
  subtitle?: ReactNode;
  right?: ReactNode;
  className?: string;
}

export function CardHeader({ title, subtitle, right, className }: CardHeaderProps): JSX.Element {
  return (
    <div
      className={cn(
        'flex items-center justify-between gap-4 border-b border-border-subtle px-4 py-3',
        className,
      )}
    >
      <div className="min-w-0">
        <h3 className="truncate text-sm font-semibold text-fg-primary">{title}</h3>
        {subtitle ? <p className="mt-0.5 truncate text-xs text-fg-muted">{subtitle}</p> : null}
      </div>
      {right ? <div className="flex shrink-0 items-center gap-2">{right}</div> : null}
    </div>
  );
}
